import type {
  AddressPin,
  PickupPoint,
  PickupPoints,
  PickupPointsWithBounds,
  PickupPointsWithNearest,
  UserAddressPin,
} from './types'

export * from './types'

export function isUserAddressPin(x?: AddressPin): x is UserAddressPin {
  return Boolean(x && x.__type === 'user-address-pin')
}

export function isYandexMarketPickupPoint(pickupPoint: PickupPoint): boolean {
  return pickupPoint._type === 'yandex_market'
}

export function isPickupPointsWithNearest(
  points: PickupPoints,
): points is PickupPointsWithNearest {
  return 'nearest' in points
}

export function isPickupPointsWithBounds(
  points: PickupPoints,
): points is PickupPointsWithBounds {
  return 'bounds' in points
}
